/**
 * Estilos para a página de configurações.
 *
 * Este módulo contém os componentes estilizados utilizados para renderizar
 * a interface da página de configurações.
 *
 * @module Settings.Styles
 */

import styled from '@emotion/styled';

/**
 * Componente estilizado para o contêiner principal da página de configurações.
 *
 * Define o layout flexível em coluna para o contêiner principal com:
 * - Display flex com direção de coluna
 * - Altura e largura máximas de 100%
 * - Margem superior
 * - Fundo branco
 * - Sombra sutil
 * - Box-sizing configurado para incluir padding e borda no cálculo das dimensões
 *
 * Inclui também estilos para o contêiner de seleção de idioma:
 * - Layout flexível em coluna
 * - Espaçamento entre elementos
 * - Largura máxima de 40%
 * - Padding interno
 *
 * @type {import('@emotion/styled').StyledComponent}
 */
export const Main = styled.main`
  display: flex;
  flex-direction: column;
  max-height: 100%;
  max-width: 100%;
  margin-top: 1em;
  background-color: #ffffff;
  box-shadow: -2px 1px 7px -6px rgba(0, 0, 0, 0.6);
  box-sizing: border-box;
  .input-language {
    display: flex;
    flex-direction: column;
    gap: 15px;
    max-width: 40%;
    padding: 2em;
  }
`;
